import { lazy } from "react";
const ReportList = lazy(() => import('@/pages/report-list/ReportList'));
const listRoute = [
    {
        path: "/reportList/:name/:code",
        name: '报表列表',
        component: ReportList,
        multipleTab:"/reportList"
    }
]
export default listRoute